interface DataLayerEvent {
  event: string;
  event_category: string;
  event_action: string;
  event_label: string;
  interaction_type?: string;
  interaction_value?: string;
  [key: string]: any;
}

export const pushDataLayerEvent = (eventData: DataLayerEvent) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
};

export const createEvent = (event: string, category: string, action: string, label: string, additionalData = {}) => {
  return {
    event,
    event_category: category,
    event_action: action,
    event_label: label,
    ...additionalData,
  };
};

export const pushAddAccountEvent = (
  text: string,
  additionalData: { interaction_type?: string; interaction_value?: string } = {}
) => {
  if (text && (text.toLowerCase().includes('live account') || text.toLowerCase().includes('demo account'))) {
    const eventData = createEvent('add_account', 'add account', 'click', text, additionalData);
    pushDataLayerEvent(eventData);
  }
};

export const pushLoginEvent = (text: string, action: string) => {
  if (text && new RegExp(/log ?in/i).test(text)) {
    const eventData = createEvent('login', 'tastyfx account', action, text);
    pushDataLayerEvent(eventData);
  }
};

export const pushSpecialPageEvent = (url: string, title: string) => {
  let eventData;

  if (url === '/open-account/') {
    eventData = createEvent('add_account', 'add account', 'page viewed', title, {
      interaction_type: 'page viewed',
      interaction_value: title,
    });
  } else if (url === '/login/') {
    eventData = createEvent('login', 'tastyfx account', 'page viewed', title, {
      interaction_type: 'page viewed',
      interaction_value: title,
    });
  }

  if (eventData) {
    pushDataLayerEvent(eventData);
  }
};
